<template>
    <div>

        <div class="handlecheck" v-if="checktrue == false">
            {{ checknumber }}
            <el-checkbox-group v-model="checked1">

                <el-checkbox :label="checknumber"></el-checkbox>

            </el-checkbox-group>

        </div>

        <div class="handlecheck" v-if="checktrue == true">

            <el-checkbox-group v-model="checked2">

                <el-checkbox :label="checknumber"></el-checkbox>

            </el-checkbox-group>

        </div>

    </div>
</template>
  
<script>
import { mapGetters, mapState } from "vuex";
export default {
    data() {
        return {
            checked: [],
            checked1: [],
            checked2: false,
        }
    },
    props: {
        checknumber: String
    },
    watch: {
        checktrue() {
            console.log(this.checktrue)
            if (this.checktrue == true) {
                this.checked2 = true
            }
        }
    },
    computed: {
        ...mapState("whatsappChat", {
            audiencecheckbox: "audiencecheckbox",
            checktrue: "checktrue"
        }),
        ...mapState("AgentRouting", {
            checknumber: "checknumber",
        }),
    },
    methods: {

    }
}
</script>
